import { createContext } from 'react';

export const FieldLanguageContext = createContext('et');
